require('./myProfileKeysTppsView.scss');

// @ vendors
const React = require('react');
const { connect } = require('react-redux');
const PropTypes = require('prop-types');
const moment = require('moment');
//const Router = require('react-router');
//const classNames = require('classnames');

// @ commons
const { OKCover } = require('commonsComponents/OKCover');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKButton } = require('components/commons/OKButton/OKButton');
const WebappRender = require('components/conditionalRender/webappRender');
const { OKIconIllustrative } = require('commonsComponents/OKIconIllustrative');
const { getTppTypeKey } = require('utilities/tpps/tppKeysHelper');
const { PopoverMenu } = require('commonsComponents/popoverMenu');
const { EmptyState } = require('commonsComponents/emptyState');
const { LoadingSection } = require('commonsComponents/loadingSection');
const { OKLoadingErrorMessage } = require("commonsComponents/OKLoadingErrorMessage")

//@actions
const myProfileKeysTppsActions = require('actions/myProfileKeysTpps/myProfileKeysTpps');

//@helpers
const { FormattedText, formatText, getFinalTitle } = require('core/i18n').i18n;

// @ constants
//const { TPP_KEYS_STATUS_ACTIVE, TPP_KEYS_STATUS_DELETED } = require('constants/tpps');

class MyProfileKeysTppsView extends React.Component {
    componentDidMount = () => {
       this.props.requestTppKeysData();
    }

    buildEmptyErrorState = (error = false) => {
        const primaryText = error ? formatText('keysTppView-noTPPError') : formatText('keysTppView-noTPP');

        return(
            <div>
                <div className="col-md-12 col-md-8-cc-12">
                    <section className="my-profile-keys-tpps-view__empty-state-card-tpp">
                        <EmptyState
                            primaryText={primaryText}
                            iconType="noitems-banking"
                        />
                    </section>
                </div>
            </div>
        )
    }

    buildCardStepsTPPBody = () => {
        return (
            <div>
                <div className="keys-view__info-icon">
                    <OKIconIllustrative icon="info" product="banking" />
                </div>
                <ul className="contact-info-box__list">
                    <li className="contact-info-box__list-item">
                        <FormattedText
                            className="contact-info-box__list-item-value"
                            value="keysTppView-newSideBoxBody01"
                        />
                    </li>
                    <li className="contact-info-box__list-item">
                        <FormattedText
                            className="contact-info-box__list-item-value"
                            value="keysTppView-newSideBoxBody02"
                        />
                    </li>
                    <li className="contact-info-box__list-item">
                        <FormattedText
                            className="contact-info-box__list-item-value"
                            value="keysTppView-newSideBoxBody03"
                        />
                    </li>
                </ul>
            </div>
        );
    }

    renderButtonOptions() {
        const optionsText = formatText("keysTppView-options");
        return (
            <OKButton
                modifier="ghost"
                rightIcon="icon-dropdown-abrir"
                smallRightIcon
            >
                {optionsText}
            </OKButton>
        );
    }

    buildOptionsMenuButton(tppId) {
        const options = [
            {
                link: `/myprofile/keys/tpps/detailTppKey/${tppId}`,
                text: formatText("keysTppView-manageConsents")
            }]

            return (
                <div className="tpps-accordion-row__options-menu">
                    <PopoverMenu
                        target={this.renderButtonOptions()}
                        items={options}
                        placement="bottomRight"
                    />
                </div>
            );
    }

    buildLinkDetails = (tpp) => {
        const tppName = tpp.get('name');
        return (
            <span className="my-profile-keys-tpps-view__list__cell--link">
                <div>{tppName}</div>
            </span>
        )
    }

    buildButtonSection = (tppId) => {
        const contentButtons = this.buildOptionsMenuButton(tppId); 
        return (
            <div key="buttonOptions" className="my-profile-keys-tpps-view__list__cell col-xs-2 my-profile-keys-tpps-view__list__options-menu">
                {contentButtons}
            </div>
        );
    }

    buildTppRow = (tpp) => {
        const tppId = tpp.get('id');
        const creationDate = tpp.get('creationDate');
        const tppTypeKey = getTppTypeKey(tpp);

        const formatDateCreated = moment(tpp.get('creationDate')).format('DD MMM YYYY');
        const buttonSection = __CONTACT_CENTER__? null : this.buildButtonSection(tppId);
        const buildLinkDetails = this.buildLinkDetails(tpp);

        return (
            <div key={creationDate+tppId} className="my-profile-keys-tpps-view__list">
                <div className="my-profile-keys-tpps-view__list__row">
                    <div className="row">
                        <div key="name" className="my-profile-keys-tpps-view__list__cell col-xs-4">
                            {buildLinkDetails}
                        </div>
                        <div key="createdDate" className="my-profile-keys-tpps-view__list__cell col-xs-4">
                            <span className="my-profile-keys-tpps-view__list__cell--disabled">
                                {tppTypeKey && <FormattedText value={tppTypeKey}/>}
                            </span>
                        </div>
                        <div key="renewDate" className="my-profile-keys-tpps-view__list__cell col-xs-2">
                            <span className="my-profile-keys-tpps-view__list__cell--disabled">
                                {formatDateCreated}
                            </span>
                        </div>
                        {buttonSection}
                    </div>
                </div>
            </div>
        );
    }

    /* se deja comentado para futura implementacion.
    buildTppRow = (tpp) => {
        const { loadMovements, setExpandedTppKeyAccordion } = this.props;
        //const showActives = immProfileKeysTpps.get('showActives');
        return (
            <TppKeyAccordionRow
                tpp={tpp}
                //showActives={showActives}
                loadMovements={loadMovements}
                setExpandedTppKeyAccordion={setExpandedTppKeyAccordion}
            />
        )
    }*/

    buildList = () => {
        const { immProfileKeysTpps } = this.props;
        //const showActives = immProfileKeysTpps.get('showActives');
        //const tppActives = immProfileKeysTpps.get('tpps').filter(tpp => tpp.get('status') === TPP_KEYS_STATUS_ACTIVE);
        //const tppDeleted = immProfileKeysTpps.get('tpps').filter(tpp => tpp.get('status') === TPP_KEYS_STATUS_DELETED);
        //const tppList = showActives ? tppActives : tppDeleted;
        const tppRows = immProfileKeysTpps.get('tpps').entrySeq().map(entry => this.buildTppRow(entry[1]));
        const name = formatText('keysTppView-nameAliasTPP');
        const dateCreated = formatText('keysTppView-dateCreated');
        const typeTpp = formatText('keysTppView-typeTPP');
        const error =  immProfileKeysTpps.get('isErrorRequest');

        /* const tppHeaderClass = classNames('my-profile-keys-tpps-view__header',{
            'my-profile-keys-tpps-view__header--inactives': !showActives
        }, 'row'); */

        return (
            <OKLoadingErrorMessage
                error={error}
                loading={immProfileKeysTpps.get('isFetchingRequest')}
            >
                <div className="col-xs-12 col-md-12">
                    <div className="my-profile-keys-tpps-view__table">
                        <div className="my-profile-keys-tpps-view__header">
                            <div className="my-profile-keys-tpps-view__header__cell col-xs-4">{name}</div>
                            <div className="my-profile-keys-tpps-view__header__cell col-xs-4">{typeTpp}</div>
                            <div className="my-profile-keys-tpps-view__header__cell col-xs-2">{dateCreated}</div>
                            <div className="my-profile-keys-tpps-view__header__cell col-xs-2"></div>
                        </div>
                        <div className="my-profile-keys-tpps-view__body">
                            {tppRows}
                        </div>
                    </div>
                </div>
            </OKLoadingErrorMessage>
        )
    }

    render() {
        const { immProfileKeysTpps } = this.props;
        // const showActives = immProfileKeysTpps.get('showActives');
        const hasTpps = immProfileKeysTpps.get('tpps') && immProfileKeysTpps.get('tpps').size > 0;
        const error =  immProfileKeysTpps.get('isErrorRequest');
        const isFetching = immProfileKeysTpps.get('isFetchingRequest');
        // const activesNumber = tpps ? immProfileKeysTpps.get('tpps').filter(tpp => tpp.get('status') === TPP_KEYS_STATUS_ACTIVE).size : 0;
        // const timedOutNumber = tpps ? immProfileKeysTpps.get('tpps').filter(tpp => tpp.get('status') === TPP_KEYS_STATUS_DELETED).size : 0;
        let content;
        if (isFetching) {
            content = <LoadingSection />
        } else if (hasTpps && !error) {
            content = this.buildList()
        } else if(!hasTpps && error) {
            content = this.buildEmptyErrorState(error);
        }

        const mappingBreadcrumb = [
            ...(!__CONTACT_CENTER__ ? [
                {
                    text: formatText('profileKeysLanding-title'),
                    url: '/myprofile/keys'
                }
            ] : []),
            {
                text: formatText('profileKeysLanding-changeTPP'),
                url: ''
            }
        ];
        /* const headerLeftTabClassName = classNames('my-profile-keys-tpps-view__header-tab', {
            'my-profile-keys-tpps-view__header-tab--active': showActives,
            'my-profile-keys-tpps-view__header-tab--left': showActives
        });
        const headerRightTabClassName = classNames('my-profile-keys-tpps-view__header-tab my-profile-keys-tpps-view__header-tab--right', {
            'my-profile-keys-tpps-view__header-tab--active': !showActives
        }); */

        return (
            <div>
                <div className="container-fluid">
                    <div className="row">
                        <OKCover size="large" section="accounts" customClass="col-xs-12">
                            <div className="my-profile-keys-tpps-view__header-sub-page">
                                <OKHeaderSubPage
                                    titleWrap={true}
                                    breadcrumbConfig={mappingBreadcrumb}
                                    finalTitle={getFinalTitle('profileKeysLanding-changeTPP')}
                                />
                            </div>
                            {/* <div className="my-profile-keys-tpps-view__header-tabs">
                                <div className={headerLeftTabClassName} onClick={updateTppKeysTab}>
                                    <FormattedText
                                        value="profileKeysTPP-activesTPP"
                                        injectedStrings={[activesNumber]}
                                    />
                                </div>
                                <div className={headerRightTabClassName} onClick={updateTppKeysTab}>
                                    <FormattedText
                                        value="profileKeysTPP-timedOutTPP"
                                        injectedStrings={[timedOutNumber]}
                                    />
                                </div>
                            </div> */}
                            <WebappRender>
                            </WebappRender>
                        </OKCover>
                    </div>
                </div>
                <div className="grid-view__body">
                    <div className="container-fluid">
                        <div className="row grid-view--content-position-positive">
                            {content}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

MyProfileKeysTppsView.propTypes = {
    requestTppKeysData: PropTypes.func.isRequired,
    immProfileKeysTpps: PropTypes.object.isRequired,
    loadMovements: PropTypes.func.isRequired,
    setExpandedTppKeyAccordion: PropTypes.func.isRequired,
    //updateTppKeysTab: PropTypes.func.isRequired
}

module.exports.constructor = MyProfileKeysTppsView;
module.exports.MyProfileKeysTppsView = connect(
    state => ({
        immProfileKeysTpps: state.myProfileKeysTpps
    }), {
        loadMovements: myProfileKeysTppsActions.loadMovements,
        requestTppKeysData: myProfileKeysTppsActions.requestTppKeysData,
        setExpandedTppKeyAccordion: myProfileKeysTppsActions.setExpandedTppKeyAccordion,
        //updateTppKeysTab: myProfileKeysTppsActions.updateTppKeysTab
    }
)(MyProfileKeysTppsView);
